export default function checkSwift(swiftNumber: string) {
  return Boolean(swiftNumber.match('[A-Z0-9]{8,11}'))
}
